import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTE_PATHS } from "../../constants/Router";
import { A_FLAG, A_MONTHLY, A_SELLING, R_ANALYTICS, R_GENERAL, R_SETTING, R_SPECIAL } from "../../text-data";
const AnalyticsTopNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const icons = [
    // Define your icon data here
    { label: A_MONTHLY, navigateTo: ROUTE_PATHS.Analytics },
    { label: A_SELLING, navigateTo: ROUTE_PATHS.AnalyticsSelling },
    { label: A_FLAG, navigateTo: ROUTE_PATHS.AnalyticsFlag },
  ];
  const index = icons.findIndex((icon) =>
    location.pathname.endsWith(icon.navigateTo)
  );
  const [activeIndex, setActiveIndex] = useState(index > 0 ? index : 0); // Initial active index
  const handleClick = (index) => {
    navigate(icons[index].navigateTo);
    setActiveIndex(index);
  };

  return (
    <div className="top-nav-container">
      <ul className="top-nav-list analytics">
        {icons.map((item, index) => (
          <li
            key={index}
            className={`top-nav-item ${activeIndex === index ? "active" : ""}`}
            onClick={() => handleClick(index)}
          >
            <span className={`top-nav-label`}>{item.label}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default AnalyticsTopNav;
